import { useGetDomainsQuery } from '../../app/api/domains.api';

/** Prefetch domain catalog so display names resolve from localStorage. */
const DomainCatalogBootstrap = () => {
  useGetDomainsQuery();
  return null;
};

export default DomainCatalogBootstrap;
